/*
 * @Author: Ly
 * @Date: 2016-03-28 
 * @LastEditTime: 2021-12-10 18:07:22
 * @LastEditors: tanyaohua
 * @FilePath: \xjmediacloud\app\editingCenter\service\editIsLockService\editIsLockService.js
 * @Description:  编辑按钮是否加锁
 */
'use strict';

angular.module('editIsLockModule', []).factory('editIsLock', ['$q', 'trsHttpService', '$window', 'localStorageService', 'modalDialog', function($q, trsHttpService, $window, localStorageService, modalDialog) {
    // 监听编辑页面关闭后的稿件解锁
    $window.addEventListener('storage', function(e) {
        var draftInfo;
        var subjectMetadata;
        try {
            draftInfo = JSON.parse(localStorageService.get('unLocakDraft'));
            subjectMetadata = JSON.parse(localStorageService.get('saveSubjectInnerLog'));
        } catch (e) {
            // 
        } finally {
            if (draftInfo && draftInfo.metadataid) {
                localStorageService.remove('unLocakDraft');
                normalLock(draftInfo.metadataid).then(() => {
                    
                });
            }
            if (subjectMetadata) {
                // 在新建稿件未保存时删除专题稿分组日志的同时，会同时删除专题稿分组
                localStorageService.remove('saveSubjectInnerLog');
                var params = {
                    serviceid: 'mlf_specialdocinnerlog',
                    methodname: 'saveSpecialDocInnerLog',
                    MetaDataId: subjectMetadata.METADATAID,
                    SpecialGroupIds: subjectMetadata.specialGroupIds
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                });
            }
        }
    });

    /**
     * [normalLock description] 普通解锁
     * @param   {[type]}  metedataid  [metedataid description]
     * @return  {[type]}              [return description]
     */
    function normalLock(metedataid) {
        var defer = $q.defer();
        var params = {
            'serviceid': 'mlf_metadata',
            'methodname': 'unLock',
            'MetaDataId': metedataid,
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
            defer.resolve(data);
        });
        return defer.promise;
    }

    /**
     * [forceDeblocking description] 强制解锁
     * @param   {[type]}  item  [item description]
     * @return  {[type]}        [return description]
     */
    function forceDeblocking(item) {
        var defer = $q.defer();
        var params = {
            'serviceid': 'mlf_metadata',
            'methodname': 'forcedUnLockMetaData',
            'MetaDataId': item.METADATAID,
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
            defer.resolve(data);
        });
        return defer.promise;
    }

    /**
     * [lockDraft description] 
     * @param   {[type]}  metadata  [metadata description]
     * @return  {[type]}            [return description]
     */
    function lockDraft(metadata) {
        var params = {
            'serviceid': 'mlf_metadata',
            'methodname': 'lockDoc',
            'DocId': metadata,
        };
        trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post', true);
    }
    return {
        // 判断是否加锁
        isLock: function(item, mediaType) {
            var defer = $q.defer();
            var params = {
                'serviceid': 'mlf_metadata',
                'methodname': 'checkLock',
                'MetaDataId': item.METADATAID,
                'MediaType': mediaType
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                defer.resolve(data);
            });
            return defer.promise;
        },
        // 是否强制解锁
        forceDeblocking: function(item) {
            var defer = $q.defer();
            forceDeblocking().then(function(data) {
                defer.resolve(data);
            });
            return defer.promise;
        },
        // 正常解锁
        normalLock: function(metadata) {
            var deffer = $q.defer();
            normalLock(metadata).then(function(data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        },
        // 锁定稿件
        lockDraft: function(metadata) {
            lockDraft(metadata);
        },
        // 解锁权限校验
        checkUnlockPermissions: function(item, data) {
            var deffer = $q.defer();
            // 这里要做个判断，部门字段可能为空
            if (angular.isDefined(data.ISHASRIGHT) && data.ISHASRIGHT === 'true') {
                modalDialog.alertType(data.LOCKUSERDEPT ? '稿件已经被【' + data.LOCKUSERDEPT + '-' + data.LOCKUSER + '】锁定,暂时不能进行操作' : '稿件已经被【' + data.LOCKUSER + '】锁定,暂时不能进行操作', '', 'warning', true, function() {
                    forceDeblocking(item).then(function(data) {
                        deffer.resolve();
                    });
                }, function() {}, '', '', '强制解锁');
            } else {
                modalDialog.alertType(data.LOCKUSERDEPT ? '稿件已经被【' + data.LOCKUSERDEPT + '-' + data.LOCKUSER + '】锁定,暂时不能进行操作' : '稿件已经被【' + data.LOCKUSER + '】锁定,暂时不能进行操作', '', 'warning');
            }
            return deffer.promise;
        }
    };
}]);
